import { useState, useCallback, useEffect } from 'react';
import { caySamApiService } from 'src/api/caysam-api';
import { CaySam } from 'src/types/caysam';

export type FeaturedItem = {
  id: string;
  title: string;
  description: string;
  coverUrl: string;
};

export default function useFeaturedCaySam() {
  const [featuredList, setFeaturedList] = useState<FeaturedItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getFeaturedCaySams = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await caySamApiService.getCaySamByUser();

      if (response.messCode === 1) {
        const items = Array.isArray(response.items) ? (response.items as CaySam[]) : [];

        const formattedData: FeaturedItem[] = items.map((item) => {
          
          let imageUrl = 'https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_1.jpg'; 
          
          if (item.caySamNhatKys && item.caySamNhatKys.length > 0) {
            const validLogs = item.caySamNhatKys.filter(log => log !== null);
            const latestLog = validLogs.sort((a, b) => {
                const dateA = new Date(a!.ngayGhi).getTime();
                const dateB = new Date(b!.ngayGhi).getTime();
                return dateB - dateA;
            })[0];
            
            if (latestLog) {
                if (latestLog.hinhAnhTongQuan) {
                  imageUrl = latestLog.hinhAnhTongQuan;
                } else if (latestLog.hinhAnhChiTiet) {
                  imageUrl = latestLog.hinhAnhChiTiet;
                }
            }
          } else if (item.loSam?.hinhAnh) {
            imageUrl = item.loSam.hinhAnh;
          }

          const latestLog = item.caySamNhatKys?.[0];
          const healthScore = latestLog?.diemSucKhoe ?? 'Chưa đánh giá';
          const tinhTrang = latestLog?.tinhTrang === 1 ? 'Tốt' : 'Cần theo dõi';
          
          const description = `Vị trí: ${item.viTriTrongLo} \nSức khỏe: ${healthScore}/10 \nTuổi: ${item.tuoiCay_ID} năm`;

          return {
            id: item.caySam_ID,
            title: item.maCaySam ? `Sâm Ngọc Linh - ${item.maCaySam}` : 'Sâm Ngọc Linh (Mới)',
            description,
            coverUrl: imageUrl,
          };
        });

        setFeaturedList(formattedData.slice(0, 5));
      } else {
        setFeaturedList([]);
      }
    } catch (err: any) {
      console.error('Lỗi khi tải danh sách cây sâm nổi bật:', err);
      setError(err.message || 'Không thể tải dữ liệu');
      setFeaturedList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getFeaturedCaySams();
  }, [getFeaturedCaySams]);

  return {
    featuredList,
    loading,
    error,
    refresh: getFeaturedCaySams
  };
}